import { render, staticRenderFns } from "./playlists-index.vue?vue&type=template&id=dc6468ba&"
import script from "./playlists-index.vue?vue&type=script&lang=js&"
export * from "./playlists-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports